export const config = {
  excludedPaths: [
    '/shops',
    '/select-treatment',
    '/treatment-category',
    '/treatment-brand',
  ],
};
